import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings"
import { Chip } from "@mui/material"
import { useRouter } from "next/router"
import { useContext } from "react"
import type { FC } from "react"
import { UserRole, useViewerUserQuery } from "interface/__generated__/react"
import { AppContext } from "interface/contexts/appContext"

/**
 * 管理者(ADMIN / SYSTEM)アカウントでログインしているときだけ、ヘッダーに
 * 小さなバッジを表示する。クリックで管理パネル(/admin/dashboard)へ遷移する。
 * 通常ユーザーには何も出さない(UIノイズを避け、例外時だけ現れる表示にする)。
 *
 * viewer クエリはログイン時のみ発火させる(未ログインページで叩くと
 * UNAUTHORIZED を誘発しログイン誘導が走るため skip する)。role は
 * 各アプリバーが既に取得する ViewerUser と同一クエリなので Apollo の
 * キャッシュ共有で追加通信は発生しない。
 */
export const AdminBadge: FC = () => {
  const router = useRouter()
  const { isLoggedIn } = useContext(AppContext)
  const { data } = useViewerUserQuery({ skip: !isLoggedIn })

  const role = data?.viewer?.user?.role
  if (role !== UserRole.Admin && role !== UserRole.System) {
    return null
  }

  const label = role === UserRole.System ? "System" : "Admin"

  return (
    <Chip
      icon={<AdminPanelSettingsIcon />}
      label={label}
      color="warning"
      size="small"
      variant="filled"
      clickable
      onClick={() => router.push("/admin/dashboard")}
      aria-label="管理パネルを開く"
      sx={{ fontWeight: "bold", height: 22 }}
    />
  )
}
